export function beep(id: string, metadata: any) {
  return fetch(
    `http://${metadata.value.ip}:80/send_page.php?pager=${id}&type=1&msg=p&baud=1&beep=4`
  )
}
